/** Escape user input for PostgREST `ilike` patterns and quoted filter values. */
export function escapeIlikePattern(input: string): string {
  return input.replace(/\\/g, '\\\\').replace(/%/g, '\\%').replace(/_/g, '\\_');
}

/** Build `column.ilike."%value%"` safe for `.or()` (commas/quotes in value). */
export function ilikeFilter(column: string, raw: string): string {
  const pattern = `%${escapeIlikePattern(raw.trim())}%`;
  const quoted = pattern.replace(/"/g, '""');
  return `${column}.ilike."${quoted}"`;
}
